export default __webpack_public_path__ + "static/media/bg.20ec3df8.mp4";